import React from 'react';
import PropTypes from 'prop-types';
import { Content } from 'core/layouts';
import { BaasicModal} from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { FutureTasks, TasksCard,TaskNotifications } from 'application/dashboard/components';
import { TaskPreviewEdit } from 'application/dashboard/pages';

function HomeTemplate({ dashboardView, t }) {
    const {
        orderingTaskModal,
        futureTasks,
        contentLoading,
        userRoles,
        //intakeCardStore,
        //documentCardStore,
        //payorCardStore,
        //billerCardStore,
        assigneeCardStore,
        accountManagerCardStore,
        onOrderTaskDetailChange,
        taskNotificationsStore,
        openFacilityEdit,
        openPickTicketEdit,
        openNikoFacilityOrder,
        downloadNikoPickTicketExcel,
        showNoRoleMessage
    } = dashboardView;

    return (
        <div className="u-mar--x--med u-mar--y--med">
            <Content loading={contentLoading}>
                <div className="row">
                    {/* {deliveryTasks && <DailyTasks title="Delivery Tasks" data={deliveryTasks.data} onChange={deliveryTasks.onChange}/>} */}
                    {userRoles.includes("Purchasers")
                        ? futureTasks && <FutureTasks title="Future Tasks" data={futureTasks.data} onChange={futureTasks.onChange} openFacilityEdit={openFacilityEdit} openPickTicketEdit={openPickTicketEdit} openNikoFacilityOrder={openNikoFacilityOrder} downloadNikoPickTicketExcel={downloadNikoPickTicketExcel}/>
                        :
                        <React.Fragment>
                            <div className="col col-sml-12 col-med-8">
                                {!userRoles.includes("AccountManagers") && (
                                    showNoRoleMessage
                                        ? <div className="u-display--ib w--100 u-mar--bottom--sml">
                                            <div className="card card--form card--primary card--med card--flex">
                                                <h4 className="form__title form__title--preview">{t('DASHBOARD.TASKS.NO_PERSON_OR_ROLE.TITLE')}</h4>
                                                <p>{t('DASHBOARD.TASKS.NO_PERSON_OR_ROLE.DESCRIPTION')}</p>
                                            </div>
                                        </div>
                                        : <TasksCard title="Task List" onClick={onOrderTaskDetailChange} store={assigneeCardStore} />
                                )}
                                {/* <TasksCard title="FACILITY.EDIT.INTAKE_REP_LABEL" onClick={onOrderTaskDetailChange} store={intakeCardStore} />
                                <TasksCard title="FACILITY.EDIT.DOCUMENT_REP_LABEL" onClick={onOrderTaskDetailChange} store={documentCardStore} />
                                <TasksCard title="FACILITY.EDIT.PAYOR_REP_LABEL" onClick={onOrderTaskDetailChange} store={payorCardStore} />
                                <TasksCard title="FACILITY.EDIT.BILLING_REP_LABEL" onClick={onOrderTaskDetailChange}  store={billerCardStore} />*/}
                                <TasksCard title="Task List" onClick={onOrderTaskDetailChange} store={accountManagerCardStore} />
                            </div>
                            <div className="col col-sml-12 col-med-4">
                                <div className="u-display--ib w--100 u-mar--bottom--sml">
                                    <div className="card card--form card--primary card--med card--flex">
                                        <TaskNotifications title="Notifications" store={taskNotificationsStore} />
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    }

                </div>
            </Content>
            {orderingTaskModal &&
            <BaasicModal modalParams={orderingTaskModal} className="modal__content modal--med">
                <TaskPreviewEdit />
            </BaasicModal>}
        </div>
    )
}

HomeTemplate.propTypes = {
    dashboardView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(HomeTemplate);